//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import forum_block from "./items/forum_block";
import forumobjct from '../script/forumobjct'

export default {
  name: "index",
  mixins: [forumobjct],
  components: {
    forum_block
  },
  data() {
    return {
      forums_options: []
    }
  },
  created() {
    window._t = this;
    this.forums_options = []
    this.update_forums_options(this.$forum_conf.forums, this.forums_options)
    console.log('forums_options:', this.forums_options);
  },
  methods: {}
}
